export const covidInfoBannerText =
  "Thanks for your interest in our work. We are currently not updating weekly COVID-19 forecasts. Please check back later.";
